module.exports = __webpack_public_path__ + "img/logo.0eedb323.png";